import React from 'react';
import { Skeleton, Stack } from '@mui/material';

export const SkeletonLayout = ({ type, children, loading }: ISkeletonLayoutProps) => {
    const infoSkeleton = (
        <Skeleton variant={'rounded'} width={'100%'} height={'96px'} sx={{ mb: '16px' }} />
    );

    const tabsSkeleton = (
        <Stack direction={'row'} sx={{ minHeight: '48px', alignItems: 'center' }}>
            <Skeleton variant={'rounded'} width={'92px'} height={'20px'} sx={{ mr: '16px' }} />
            <Skeleton variant={'rounded'} width={'92px'} height={'20px'} />
        </Stack>
    );

    const documentSelectionSkeleton = (
        <Skeleton variant={'rounded'} width={'100%'} height={'40px'} sx={{ mb: '20px' }} />
    );

    const mainSkeleton = (
        <Stack sx={{ mb: '14px' }}>
            <Skeleton variant={'rounded'} width={'92px'} height={'20px'} sx={{ mb: '8px' }} />
            <Skeleton variant={'rounded'} width={'100%'} height={'55px'} sx={{ mb: '8px' }} />
            <Skeleton variant={'rounded'} width={'100%'} height={'55px'} sx={{ mb: '8px' }} />
        </Stack>
    );

    const documentationSkeleton = (
        <Stack sx={{ m: '14px' }}>
            <Stack direction={'row'} spacing={1}>
                <Stack>
                    <Skeleton
                        variant={'rounded'}
                        width={'190px'}
                        height={'40px'}
                        sx={{ mb: '8px' }}
                    />
                    <Skeleton
                        variant={'rounded'}
                        width={'190px'}
                        height={'40px'}
                        sx={{ mb: '8px' }}
                    />
                    <Skeleton
                        variant={'rounded'}
                        width={'190px'}
                        height={'40px'}
                        sx={{ mb: '8px' }}
                    />
                </Stack>

                <Stack
                    sx={{
                        flex: 'auto',
                    }}
                >
                    <Skeleton
                        variant={'rounded'}
                        width={'92px'}
                        height={'20px'}
                        sx={{ mb: '8px' }}
                    />
                    <Skeleton
                        variant={'rounded'}
                        width={'100%'}
                        height={'55px'}
                        sx={{ mb: '8px' }}
                    />
                </Stack>
            </Stack>
        </Stack>
    );

    const skeletons = {
        [SkeletonType.Info]: infoSkeleton,
        [SkeletonType.Tabs]: tabsSkeleton,
        [SkeletonType.DocumentSelection]: documentSelectionSkeleton,
        [SkeletonType.Main]: mainSkeleton,
        [SkeletonType.Documentation]: documentationSkeleton,
    };

    return <>{loading ? skeletons[type] : children}</>;
};

export enum SkeletonType {
    Info = 'info',
    Tabs = 'tabs',
    DocumentSelection = 'documentSelection',
    Main = 'main',
    Documentation = 'documentation',
}

/**
 * Interface that describes SkeletonLayout's props.
 */
interface ISkeletonLayoutProps extends React.PropsWithChildren {
    type: SkeletonType;
    loading?: boolean;
}
